import { useState, useEffect } from "react";

import { getLandingPage } from "../contentful";

export default function useLandingPage() {
  const [posts, setPosts] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true; // Prevent setting state if the component unmounts
    setLoading(true);

    getLandingPage().then((landingPage) => {
      if (isMounted) {
        setPosts(landingPage[0].fields.featuredBlogPosts);
        setLoading(false);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return [posts, isLoading];
}
